import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";




const operationURLS = {
  list: "predefinedMessage/list",
  update: "predefinedMessage/update",
  register: "predefinedMessage/create",
  delete: "predefinedMessage/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Type",
      accessor: "type",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      width: 12,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      options: {
        keyField: "value",
        keyDescription: "label",
        values: [
          { label: "SMS", value: "SMS" },
          { label: "Email", value: "Email" },
        ],
        url: "",
      },
    },
    {
      Header: "Message Type",
      accessor: "messageType",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().required("Required"),
      width: 12,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Message Content",
      accessor: "messageContent",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "textField",
      validation: formControl.string().required("Required"),
      width: 12,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
